import React from 'react';
import ScrollIntoView from '../components/ScrollIntoView';

const SzechenyiEnergia = () => {
  return (
    <ScrollIntoView>
      <div id="szechenyi-page">

      <div id="szechenyi-top-banner"></div>


        <div id='szechenyi_top_container'>
          <div id='szechenyi_crest'></div>
          <div id='szechenyi_top_content'>
            <p>Kedvezményezett neve: Kisújszállás Város Önkormányzata</p>
            <p>Pályázati felhívás neve: Energia menedzsment rendszer fejlesztése Kisújszálláson</p>
            <p>Projekt azonosító száma: DIMOP_PLUSZ-2.1.1-24-2025-00055</p>
          </div>
        </div>

        <div className='szechenyi_section' id='szechenyi_energia'></div>

        <div id='szechenyi_project_desc' className='szechenyi_details'>

          <h2>A projektről röviden</h2>
          <p>A Széchenyi Terv Plusz keretében megjelent „Energia menedzsment rendszerek fejlesztése és
            bevezetése önkormányzatok számára” című, DIMOP Plusz-2.1.1-24 kódszámú felhívás
            lehetőséget biztosít a kevésbé fejlett régiókban működő helyi önkormányzatok és az általuk
            vezetett konzorciumok számára biztosít lokális energiamenedzsment rendszerek tervezésére
            és bevezetésére. Kisújszállás Város Önkormányzata az energiahatékonyság javítását kiemelt
            célként kezeli, ezért az általa vezetett konzorcium a konstrukció keretében sikeres pályázatot
            nyújtott be.</p>
          <p>A megvalósuló projekt átfogó célja, hogy az Önkormányzat vezessen be egy olyan új lokális
            energiamenedzsment megoldást, amely szakmailag és technikailag megalapozott,
            megfelelőséget tanúsító szakvéleménnyel rendelkezik, előre meghatározott funkcionalitással
            bír, és hosszú távon működtethető; javítja az önkormányzati épületek energiahatékonyságát,
            elősegíti az energiatermelés és a fogyasztás optimális egyensúlyban tartását, továbbá
            rendszeres és pontos adatszolgáltatással támogatja a nemzetgazdasági és szakpolitikai
            döntések előkészítését, hozzájárulva ezzel az üvegházhatású gázok kibocsátásának
            mérsékléséhez.</p>
          <p>A kialakítani javasolt energiamenedzsment rendszer működtetése lényegesen hozzájárul az
            energiahatékonyság növeléséhez, miután a mérési eszközök által gyűjtött adatok és a
            döntéstámogató rendszerek segítségével optimalizálható a projektbe bevont épületek
            energiafelhasználása. A rendszer integrált mérési eszközök segítségével valós időben gyűjti a
            fogyasztási adatokat, ezzel lehetővé téve az energiafogyasztás pontos monitorozását, a
            rendszerszintű optimalizációt, valamint a hatékony erőforrás-elosztást. Így nem csupán a
            szén-dioxid kibocsátás csökkenése érhető el, hanem érdemi gazdasági megtakarítás is
            megvalósíthat, amely hozzájárul az önkormányzati intézmények hosszú távú
            fenntarthatóságához.</p>
          <p>A projekt megvalósítására konzorcium alakult, amelynek vezetője <b>Kisújszállás Város
            Önkormányzata</b>, tagjai:</p>
          <ul>
            <li><b>Kisújszállási Polgármesteri Hivatal</b></li>
            <li><b>Kisújszállási Városgazdálkodási Nonprofit Kft.</b></li>
            <li><b>Kumánia Gyógyfürdő Kft.</b></li>
          </ul>

          <p>A fejlesztés tervezetten az önkormányzati épületállományon belül az energiafelhasználás
            jelentős részét képviselő épületekre terjed ki, amelyek az előzetes felmérés eredménye alapján
            a következők:</p>

          <ul>
            <li>Kisújszállási Polgármesteri Hivatal</li>
            <li>Kisújszállási Művelődési és Ifjúsági Központ</li>
            <li>Vigadó Kulturális Központ</li>
            <li>Arany János Városi Könyvtár</li>
            <li>Kisújszállási Térségi Szociális Otthon</li>
            <li>Kumánia Gyógy- és Strandfürdő és Hotel</li>
            <li>Kisújszállási Piac és Vásárcsarnok</li>
            <li>POM POM Városi Bölcsőde</li>
            <li>Kisújszállási Önkormányzati Tűzoltó-Parancsnokság</li>
            <li>Háziorvosi és Üzemorvosi Rendelő</li>
            <li>Kumánia Kemping és Ifjúsági Szálláshely</li>
          </ul>

          <p>Az energiafelhasználás optimalizálására, a hatékonyság növelésére és a költségek
            csökkentésére vonatkozó javaslatok és intézkedési terv kidolgozása a rendszer üzembe
            helyezését követően, az abból származó adatok részletes elemzésével történhet meg. Az
            előzetes felmérés a következő energiamegtakarítási lehetőségeket azonosította:</p>

          <ul>
            <li>A fogyasztás valós idejű követése, fogyasztási zónák vagy épületrészek szerinti
              bontásban, rendellenes fogyasztásnövekedések esetén gyors beavatkozás azok okának
              (pl. szivárgás) megszüntetésére.</li>
            <li>A felesleges fűtési és légkondicionálási üzemidő csökkentése gazdaságosabb
              üzemmódra állítással (pl. munkaszüneti napokon) az egyes helyiségekben elhelyezett
              hőmérséklet szenzorok adatai alapján.</li>
            <li>A megújuló energiaforrásokkal termelt energia valós időben történő mérése és a
              fogyasztással (pl. vízmelegítők működtetésével) történő összehangolása.</li>
            <li>Riasztások beállítása azokra az esetekre, ha egy szivattyú, ventilátor vagy hőcserélő
              hatásfoka hirtelen lecsökken, a berendezés ellenőrzésével a veszteségek csökkentése.</li>
          </ul>

          <p>A tervezett megoldás lehetővé teszi az alábbi közművek adatköreinek mérését, továbbítását és
            elemzését azokban az épületekben, amelyek esetén az adott energiafajta jelentős fogyasztást
            képvisel:</p>

          <ul>
            <li><b>villamosenergia,</b></li>
            <li><b>földgáz,</b></li>
            <li><b>víz.</b></li>
          </ul>
        </div>

        <div id='szechenyi_project_docs' className='szechenyi_details'>

          <h2>Dokumentumok</h2>
          <div id="public-links">
            <a href="/kozerdeku/DIMOP_Plusz_2_1_1_24_Megvalosithatosagi_tanulmany_Kisujszallas_v_5_0.pdf" target="_blank" rel="noopener noreferrer">DIMOP_Plusz_2_1_1_24_Megvalosithatosagi_tanulmany_Kisujszallas_v_5_0.pdf</a>
          </div>

        </div>

        <div id='szechenyi_project_ids' className='szechenyi_details'>

          <h2>Pályázat azonosító adatai</h2>
          <p><b>Pályázat adatai:</b><br />
            <b>Kedvezményezett neve:</b> Kisújszállás Város Önkormányzata<br />
            <b>Pályázat azonosító száma:</b> DIMOP_PLUSZ-2.1.1-24-2025-00055<br />
            <b>Fejlesztés tárgya:</b> Energia menedzsment rendszer fejlesztése Kisújszálláson</p>

          <p><b>Fejlesztés célja:</b></p>
          <p>A projekt a Széchenyi Terv Plusz program keretében valósul meg 107 603 356 Ft európai
            uniós vissza nem térítendő támogatás segítségével.</p>
          <p>A projekt keretében olyan lokális energiamenedzsment rendszer és hozzá kapcsolódó
            eszközök beszerzése, telepítése és üzembe helyezése a cél, amely biztosítja, hogy az
            Önkormányzat energiahatékonyabban és biztonságosabban működjön, csökkenhető legyen az
            energiaveszteség, és a fogyasztás termelési kapacitáshoz történő igazításával hosszú távon
            költségmegtakarítás és szén-dioxid kibocsátás csökkentés valósuljon meg.</p>
          <p>A projekt megvalósítására konzorcium alakult, amelynek vezetője <b>Kisújszállás Város
            Önkormányzata</b>, tagjai pedig az alábbiak:</p>

          <ul>
            <li><b>Kisújszállási Polgármesteri Hivatal</b></li>
            <li><b>Kisújszállási Városgazdálkodási Nonprofit Kft.</b></li>
            <li><b>Kumánia Gyógyfürdő Kft.</b></li>
          </ul>

          <p>A fejlesztés keretében a Konzorcium 11 darab önkormányzati tulajdonú épületben összesen
            21 darab új mérőeszköz, 72 darab új érzékelő és 11 darab új adattovábbító eszköz
            felszerelését, valamint a bevezetésre kerülő lokális energiamenedzsment rendszerhez történő
            csatlakoztatását tervezi.</p>
          <p>A felszerelésre kerülő mérő-, érzékelő-, és adattovábbító eszközök kizárólag mérésre
            szolgálnak és nem valósítanak meg vezérlési funkciókat.</p>
          <p>Kijelölt épületek listája</p>

          <ul>
            <li>Kisújszállási Polgármesteri Hivatal</li>
            <li>Kisújszállási Művelődési és Ifjúsági Központ</li>
            <li>Vigadó Kulturális Központ</li>
            <li>Arany János Városi Könyvtár</li>
            <li>Kisújszállási Térségi Szociális Otthon</li>
            <li>Kumánia Gyógy- és Strandfürdő és Hotel</li>
            <li>Kisújszállási Piac és Vásárcsarnok</li>
            <li>POM POM Városi Bölcsőde</li>
            <li>Kisújszállási Önkormányzati Tűzoltó-Parancsnokság</li>
            <li>Háziorvosi és Üzemorvosi Rendelő</li>
            <li>Kumánia Kemping és Ifjúsági Szálláshely</li>
          </ul>
          <p>„A projekt az Európai Unió támogatásával, a magyar állam társfinanszírozásával valósult
            meg.”</p>

          <p><b>Projekt kezdés dátuma:</b> 2026.02.01.<br /></p>
          <p><b>Projekt befejezés dátuma:</b> 2027.07.31.<br /></p>
          <p><b>Szerződött támogatási összeg:</b> 107 603 356 Ft<br /></p>
          <p><b>A támogatás mértéke:</b> 100%<br /></p>
        </div>


      </div>

    </ScrollIntoView>
  );
};

export default SzechenyiEnergia;